import React from 'react';
import CustomTooltip from '../../../../../shared/components/common/tooltip/CustomTooltip';
import { t } from 'i18next';
import BarChart from '../../../../../shared/components/chart/bar-chart/BarChart';
import { useAccount } from '../../../../../shared/contexts/account/AccountContexts';
import { TagsResponse } from '../../../../../shared/models/tags/TagsResponse';
import { KeywordResponse } from '../../../../../shared/models/monitor/KeywordResponse';
import SimpleBar from 'simplebar-react';

interface ShareOfVoiceBarChartProps {
  allModelsStatsMatrix: string[][] | null;
  brandColors: { name: string; color: string }[] | null;
  firmName: string;
  keywordsMapper: Map<string, string>;
  commonKeywords: KeywordResponse[];
  tags: TagsResponse[];
}

const ShareOfVoiceBarChart: React.FC<ShareOfVoiceBarChartProps> = ({
  allModelsStatsMatrix,
  brandColors,
  firmName,
  keywordsMapper,
  commonKeywords,
  tags,
}) => {
  const { accountResponse } = useAccount();

  return (
    <div className="stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">
          {t('shareOfVoiceByLlm')}
          <CustomTooltip tooltipText="shareOfVoiceByLlmTooltip" addMargin={false} />
        </div>
      </div>

      <div className="stats-box stats-box--bar-chart">
        <div className="stats-box__content">
          <SimpleBar className="stats-box__scroll-box" style={{ maxWidth: '100%' }} autoHide={false}>
            <BarChart
              data={allModelsStatsMatrix}
              colorsByName={brandColors || undefined}
              selectedBrand={firmName}
              keywordsMapper={keywordsMapper}
              commonKeywords={commonKeywords}
              tags={tags}
            />
          </SimpleBar>
        </div>
      </div>
    </div>
  );
};

export default ShareOfVoiceBarChart;
